import { NewAgreementModal } from '@/components/modals/NewAgreementModal'
import type { EORPModalProps } from '../types'

export function EORPModal({ isOpen, onClose }: EORPModalProps) {
  return <NewAgreementModal isOpen={isOpen} onClose={onClose} />
}
